<!--
 * @Description: 开票信息
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="formData"
    :rules="formRules"
    :disabled="disabled"
  >
    <div class="form-dialog__title">
      <h1>开票信息</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="企业名称" prop="industryId">
        <BaseSelect
          v-if="!disabled"
          class="form-dialog__w280"
          placeholder="请选择"
          labelKey="industryName"
          valueKey="industryId"
          init
          :remoteMethod="industryIdRemote"
          v-model="formData.industryId"
          @change="onIndustryIdChange"
        ></BaseSelect>
        <BaseInput
          v-else
          class="form-dialog__w280"
          type="text"
          :modelValue="formData.industryName"
        />
      </BaseFormItem>
      <BaseFormItem label="纳税识别号" prop="invoiceIdentifierNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceIdentifierNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="联系电话" prop="invoicePhone">
        <BaseInput
          class="form-dialog__w280"
          type="tel"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoicePhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="开户银行" prop="invoiceOpenBank">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceOpenBank"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="银行账号" prop="invoiceBankNo">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceBankNo"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem label="企业地址" prop="invoiceEnterpriseAddress">
        <BaseInput
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          disabled
          :modelValue="formData.invoiceEnterpriseAddress"
        ></BaseInput>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref, defineExpose, defineModel, withDefaults, defineProps } from 'vue';
import { BaseForm, BaseFormItem, BaseInput, BaseSelect } from 'xrk-components';
import { listSelectEnterprise } from '@V/invoice/src/data-source/apis';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';

withDefaults(
  defineProps<{
    disabled: boolean;
  }>(),
  {
    disabled: false
  }
);

const formRef = ref(null);
const formData = defineModel<IndustryDetailData>();
const formRules = {
  industryId: [{ required: true, message: '请选择', trigger: 'change' }]
};

/**
 * @description: 获取当前企业关联的工业列表，并通过该数据完善开票信息、邮寄地址
 *               注意：工业角色该接口没有数据
 *               在禁用状态下或者工业打开时，将直接显示企业名称而不进行搜索
 */
const industryIdRemote = industryName => {
  return listSelectEnterprise({
    industryName
  });
};

const onIndustryIdChange = (v, [option]) => {
  Object.assign(formData.value, option);
};

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
